
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import parsePhoneNumber from 'libphonenumber-js'
import { Row, Col, Button, Popover, List, Card } from 'antd';
import { InfoCircleFilled, CheckOutlined } from '@ant-design/icons';
import TripEditPessengerContact from './TripEditPessengerContact';
import TripEditPessengerContactEdit from './TripEditPessengerContactEdit';

const { Meta } = Card;

class TripEditPessenger extends Component {

    constructor(props) {
        super(props);
        this.state = {
            account: null,
            contacts: [],
            passengers: props.passengers,
            isModalContactList: false,
            isModalUserList: false,
            isModalForm: false,
            contactFormType: "create",
            selectedContact: null
        };
    }

    componentWillMount() {
        this.getAccount();

    }

    componentWillReceiveProps(nextProps) {
    }

    getAccount = () => {

        let endpoint = { keyOne: "account" };

        this.props.dispatch(actions.definitions.getData({
            ...endpoint
        })).then(response => {
            this.setState({
                account: response
            }, () => {
                this.getContacts();
            });

        })
    }

    getContacts = () => {

        let endpoint = { keyOne: "contacts" };

        this.props.dispatch(actions.definitions.getData({
            ...endpoint
        })).then(response => {
            this.setState({
                contacts: response.data
            }, () => {
                this.addMeToPassengers()
            });
        })
    }


    addMeToPassengers = () => {
        let { account, passengers } = this.state;

        if (account.keepThePassengersEmptyWhileTripCreating) {

            if (!this.props.id) {
                this.props.passengers.push({
                    name: account.name,
                    lastname: account.lastname,
                    email: account.email,
                    phoneNumber: account.phoneNumber,
                    isContact: true
                })

                this.setState({ passengers })
            }

        }

    }

    toggleContactsList = () => {
        this.setState({ isModalContactList: !this.state.isModalContactList })
    }

    toggleUsersList = () => {
        this.setState({ isModalUserList: !this.state.isModalUserList })
    }

    toggleContactForm = (contactFormType, selectedContact) => {
        this.setState({ isModalForm: !this.state.isModalForm, contactFormType, selectedContact })
    }


    getPopoverMenu = (item) => {

        let content = (
            <lu className="items">
                <li className='item' onClick={() => this.props.addPassenger(item)}>Bu Kişiyi Yolculuktan Çıkar</li>
                <li className='item' onClick={() => this.toggleContactForm('update', item)}>Yolcu Bilgilerini Düzenle</li>
                <li className='item' onClick={() => this.props.changePassengerContact(item)}>İlgili Kişi Ata</li>
            </lu>
        );

        if (item.isContact) {

            content = (
                <lu className="items">
                    <li className='item' onClick={() => this.toggleContactForm('update', item)}>Yolcu Bilgilerini Düzenle</li>
                </lu>
            );

        }

        return content

    }

    render() {

        let { scrollToModule, passengers, vehicleTypes } = this.props
        let { isModalContactList, contacts, isModalUserList, isModalForm, contactFormType, selectedContact } = this.state

        return (

            <Fragment>
                <div className='module'>KİMLE KİMLERLE?</div>

                <Row>

                    {
                        passengers.map(item => {

                            return <Col xs={12} sm={12} md={12} lg={12} xl={12} key={item.email}>
                                <Popover content={this.getPopoverMenu(item)} placement='bottom' trigger="hover"
                                    overlayClassName='trip-contact-popover'
                                >
                                    <div className="box-with-icon">

                                        <div className='email'>{item.isContact ? `İLGİLİ KİŞİ` : `YOLCU`}</div>

                                        <div className='name'>{`${item.name} ${item.lastname}`}</div>
                                        <div className='phonenumber'>{parsePhoneNumber("+" + item.phoneNumber).formatInternational()}</div>
                                        <div className='email'>{item.email}</div>
                                    </div>
                                </Popover>


                            </Col>
                        })
                    }
                </Row>
                <Row className='operation'>

                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className="move-action"
                            onClick={(e) => this.toggleContactsList()}
                        >
                            <div className="image">
                                <img src="../../../assets/img/icons/add-contact-icon.png" alt="" />

                            </div>
                            <div className="text">
                                <h3>KİŞİ LİSTEMDEN EKLE</h3>
                                <p>Kişi listesinizden çoklu seçim yapabilirsiniz
                                </p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className="move-action" onClick={(e) => this.toggleContactForm("create")}>
                            <div className="image">
                                <img src="../../../assets/img/icons/edit-contact-icon.png" alt="" />
                            </div>
                            <div className="text">
                                <h3>YENİ KİŞİ EKLE</h3>
                                <p>Yeni kişiyi manuel olarak ekşeyebilirsiniz
                                </p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className="move-action" onClick={(e) => this.toggleUsersList()}>
                            <div className="image">
                                <img src="../../../assets/img/icons/edit-contact-icon.png" alt="" />
                            </div>
                            <div className="text">
                                <h3>ÜYE KULLANICILARDAN SEÇ</h3>
                                <p>Üye kullanıcılardan seç</p>
                            </div>
                        </div>
                    </Col>
                </Row>



                <Row className='vehicletype'>

                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <div className='info'>
                            <InfoCircleFilled />
                            <span className='info-text'>{`Belirtilen ${this.props.passengers.length} kişi için uygun olan araçlar aşağıda listelenmiştir. Lütfen seçiminizi yapınız`}</span>
                        </div>

                    </Col>

                </Row>
                <Row className='vehicletype list'>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <List
                            grid={{
                                gutter: 14,
                                column: 5,
                            }}
                            dataSource={vehicleTypes.filter(x => x.capacity >= this.props.passengers.length)}
                            renderItem={(item) => (
                                <List.Item
                                    onClick={() => this.props.onSelectVehicleType(item)}
                                >
                                    <Card
                                        style={{
                                            width: 150,
                                        }}
                                        cover={
                                            <img
                                                alt={item.name}
                                                src={item.imagePath}
                                                style={{ width: 150, height: 90 }}
                                            />
                                        }
                                        actions={[
                                            <Button
                                                type={this.props.vehicleTypeId === item.id ? "default" : "link"}
                                                icon={this.props.vehicleTypeId === item.id && <CheckOutlined />}
                                                style={{ height: 32 }}
                                            >
                                                {this.props.vehicleTypeId === item.id ? "Seçili" : "Seç"}
                                            </Button>
                                        ]}
                                        size='small'
                                    >
                                        <Meta
                                            title={item.name}
                                            description={`${item.capacity} Kişilik`}
                                        />

                                    </Card>
                                </List.Item>
                            )}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Button
                            htmlType="submit"
                            type="default"
                            className="ant-btn width-100"
                            style={{ float: "right", height: 40, marginTop: 25, marginRight: 10 }}
                            onClick={(e) => scrollToModule("when")}
                        >
                            Önceki
                        </Button>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Button
                            htmlType="submit"
                            type="primary"
                            className="ant-btn width-100"
                            style={{ float: "right", height: 40, marginTop: 25 }}
                            onClick={(e) => scrollToModule("where")}
                        >
                            Devam
                        </Button>
                    </Col>
                </Row>



                <TripEditPessengerContact
                    handleToggle={this.toggleContactsList}
                    isModalContactList={isModalContactList}
                    contacts={contacts}
                    passengers={passengers}
                    addPassenger={this.props.addPassenger}
                    type={"contact"}
                />

                <TripEditPessengerContact
                    handleToggle={this.toggleUsersList}
                    isModalContactList={isModalUserList}
                    contacts={contacts}
                    passengers={passengers}
                    addPassenger={this.props.addPassenger}
                    type={"user"}
                />

                <TripEditPessengerContactEdit
                    handleToggle={this.toggleContactForm}
                    isModalOpen={isModalForm}
                    addPassenger={this.props.addPassenger}
                    type={contactFormType}
                    selectedContact={selectedContact}
                    changePassenger={this.props.changePassenger}
                />

            </Fragment>
        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripEditPessenger);


// WEBPACK FOOTER //
// ./src/components/App/Views/Trip/TripEditPessenger.js